import React, { memo, useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';
import styles from './index.module.scss';

type Point = { left: number; top: number };

interface Props {
  points: Point[];
  duration?: number;
  // onSegmentEnd?: (index: number) => void;
}

const SVGBrokenLine: React.FC<Props> = ({ points,duration = 500 }) => {
  const svgRef = useRef<SVGSVGElement>(null);

  // useEffect(() => {
  //   let index = 0;
  //   if (!points || points.length < 2) return;
  //   const timer = setInterval(() => {
  //     if(index <= points.length - 1) {
  //       onSegmentEnd?.(index);
  //       index += 1;
  //     } else {
  //       clearInterval(timer);
  //     }
  //   }, duration);
  //   return () => clearInterval(timer);
  // }, [points, duration]);

  useEffect(() => {
    if (!points || points.length < 2 || !svgRef.current) return;

    // 清除之前的路径
    d3.select(svgRef.current).selectAll('*').remove();

    // 创建曲线生成器
    const line = d3.line<Point>()
      .x(d => d.left)
      .y(d => d.top)
      .curve(d3.curveBumpX);

    // 生成路径数据
    const pathData = line(points);
    if (!pathData) return;

    // 获取路径总长度
    const pathLength = d3.select(svgRef.current)
      .append('path')
      .attr('d', pathData)
      .attr('fill', 'none')
      .attr('stroke', 'rgba(255,255,255,1)')
      .attr('stroke-width', '8')
      .attr('stroke-linecap', 'round')
      .node()
      ?.getTotalLength();

    if (!pathLength) return;

    // 清除临时路径
    d3.select(svgRef.current).selectAll('path').remove();

    // 绘制路径并添加动画
    d3.select(svgRef.current)
      .append('path')
      .attr('d', pathData)
      .attr('fill', 'none')
      .attr('stroke', 'rgba(255,255,255,1)')
      .attr('stroke-width', '8')
      .attr('stroke-linecap', 'round')
      .attr('stroke-dasharray', pathLength)
      .attr('stroke-dashoffset', pathLength)
      .transition()
      .duration(duration * points.length)
      .ease(d3.easeLinear)
      .attr('stroke-dashoffset', 0);

  }, [points, duration]);

  return (
    <div className={styles.svgBrokenLine}>
      <svg 
        ref={svgRef}
        width="100%" 
        height="100%" 
        style={{ position: 'absolute', top: 0, left: 0 }}
      />
    </div>
  );
};

export default memo(SVGBrokenLine);
